import { Box, Stack } from "@mui/material";
import type { JSX } from "react";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { codeItemStyles, getHighlightedSyntax } from "./helpers/codeHelper";
import PrettyCodeDisplay from "./PrettyCodeDisplay";

interface Props {
  code: string;
  isLoading: boolean;
  Header: JSX.Element;
}
const CodeContainer = ({ code, isLoading, Header }: Props) => {
  const rows = getHighlightedSyntax(code, codeItemStyles);

  return (
    <Stack useFlexGap spacing={1}>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        {Header}
      </Stack>
      <Stack
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          bgcolor: "background.grey",
          overflow: "hidden",
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      >
        <Box sx={{ width: "100%", height: "100%", overflowY: "auto", position: "relative" }}>
          {isLoading && <InlineLoader overlay />}
          <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
            <Stack sx={{ height: "100%", flex: "1 0 auto" }}>
              <PrettyCodeDisplay rows={rows} />
            </Stack>
          </Box>
        </Box>
      </Stack>
    </Stack>
  );
};

export default CodeContainer;
